export const HELLO = 'Hello'
